var module = angular.module('octopusApp.certificates');

module.controller('CertificatesIndexController', function ($scope, busy, octopusRepository, $location, $state) {
    var vm = this;

    vm.archived = $state.current.data.archived;
    vm.search = $location.search().search;
    vm.isEmpty = false;
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/certificates/index/certificates_index_controller.js
// module id = 8935488079471894
// module chunks = 1